import * as alertActionTypes from '../store/alert/alertActionTypes';
import { put, call } from 'redux-saga/effects'; 
import { logoutSaga } from '../store/account/userSaga';
import { translations } from '../translations';

const getCurrentLanguage = () => {
  return localStorage.getItem('language') || 'tr';
};

const t = (key) => {
  const language = getCurrentLanguage();
  return translations[language]?.[key] || translations['tr'][key] || key;
};

const clearSession = () => {
  console.log('Clearing session data from errorHandler...');
  localStorage.removeItem('token');
  localStorage.removeItem('user');
  localStorage.removeItem('sessionUserId');
  localStorage.removeItem('temp_token');
  localStorage.removeItem('authToken');
};

export function* errorHandler(error, history, href) {
  console.log('errorHandler called with:', { error, history, href });
  
  // Token expired kontrolü - 400 status code ile gelen token expiry hatası
  if (error?.response?.status === 400 && 
      error?.response?.data?.Result?.ErrorDescription?.includes('token is expired')) {
    console.log('Token expired detected - clearing session and redirecting to login');
    
    clearSession();
    
    try {
      yield call(logoutSaga);
    } catch (logoutError) {
      console.error('Error during logout:', logoutError);
    }

    yield put({
      type: alertActionTypes.SET_ALERT,
      msg: {
        title: t('sessionTimeoutTitle'),
        text: t('sessionExpired') || 'Oturumunuz sona erdi. Lütfen tekrar giriş yapın.',
        variant: 'warning',
        outTimeMS: 6000,
      },
    });

    // Login sayfasına yönlendir
    setTimeout(() => {
      window.location.href = '/login';
    }, 2000);
    
    return;
  }
  
  if (error?.response?.status === 403) {
    console.log('403 Forbidden - calling logout and clearing session');
    
    clearSession();
    
    try {
      yield call(logoutSaga);
    } catch (logoutError) {
      console.error('Error during logout:', logoutError);
    }

    yield put({
      type: alertActionTypes.SET_ALERT,
      msg: {
        title: t('sessionTimeoutTitle'),
        text: error?.response?.data?.Result?.ErrorDescription ||
              error?.response?.data?.message || 
              t('sessionTimeoutMessage'),
        variant: 'danger',
        outTimeMS: 6000,
      },
    });

    // Login sayfasına yönlendir
    setTimeout(() => {
      window.location.href = '/login';
    }, 2000);
    
    return;
  } 
  
  else if (error?.response?.status === 401) {
    console.log('401 Unauthorized - session expired');
    
    clearSession();
    
    try {
      yield call(logoutSaga);
    } catch (logoutError) {
      console.error('Error during logout:', logoutError);
    }

    yield put({
      type: alertActionTypes.SET_ALERT,
      msg: {
        title: t('sessionTimeoutTitle'),
        text: error?.response?.data?.Result?.ErrorDescription ||
              error?.response?.data?.message || 
              t('unauthorizedError'),
        variant: 'warning',
        outTimeMS: 6000,
      },
    });

    // Login sayfasına yönlendir
    setTimeout(() => {
      window.location.href = '/login';
    }, 2000);
    
    return;
  }
  
  else if (error?.response?.status === 422) {
    console.log('422 Validation Error - not showing generic alert');
    
    return;
  }
  
  else if (error?.message === 'Network Error') {
    console.log('Network Error detected in errorHandler');
    
    clearSession();
    
    yield put({
      type: alertActionTypes.SET_ALERT,
      msg: {
        title: t('networkError'),
        text: t('networkErrorSessionTimeout'),
        variant: 'danger',
        outTimeMS: 6000,
      },
    });

    setTimeout(() => {
      window.location.href = '/login';
    }, 2000);
    
    return;
  }
  
  else if (error?.response) {
    console.log(`HTTP Error ${error.response.status}:`, error.response.data);
    
    let errorTitle = t('httpError');
    let errorMessage = t('requestFailedError');
    
    // Önce API'den gelen ErrorDescription'ı kontrol et
    const apiErrorMessage = error.response.data?.Result?.ErrorDescription;
    
    if (apiErrorMessage) {
      errorMessage = apiErrorMessage;
    } else {
      // ErrorDescription yoksa HTTP status'a göre mesaj ver
      switch (error.response.status) {
        case 400:
          errorTitle = t('badRequestError');
          errorMessage = t('badRequestError');
          break;
        case 404:
          errorTitle = t('notFoundError');
          errorMessage = t('notFoundError');
          break;
        case 413:
          errorTitle = t('payloadTooLargeError') || 'Dosya Çok Büyük';
          errorMessage = t('fileTooLargeError') || 'Yüklemek istediğiniz dosya çok büyüktür.';
          break;
        case 500:
          errorTitle = t('serverError');
          errorMessage = t('internalServerError');
          break;
        case 503:
          errorTitle = t('serverError');
          errorMessage = t('serviceUnavailableError');
          break;
        default:
          errorMessage = error.response.data?.message || t('requestFailedError');
      }
    }

    yield put({
      type: alertActionTypes.SET_ALERT,
      msg: {
        title: errorTitle,
        text: errorMessage,
        variant: 'danger',
        outTimeMS: 6000,
      },
    });
  }
  
  else if (error?.request) {
    console.log('Network request failed - no response received');
    
    yield put({
      type: alertActionTypes.SET_ALERT,
      msg: {
        title: t('networkError'),
        text: t('connectionErrorMessage'),
        variant: 'danger',
        outTimeMS: 6000,
      },
    });
  }
  
  else {
    console.log('General error in errorHandler:', error);
    
    yield put({
      type: alertActionTypes.SET_ALERT,
      msg: {
        title: t('unexpectedError'),
        text: error?.message || t('unexpectedErrorMessage'),
        variant: 'danger',
        outTimeMS: 6000,
      },
    });
  }
}

export default errorHandler;